import type { Visit } from '../services/api';

/** A booking can cover several services; the listing shows them on one line. */
export function serviceNames(visit: Visit): string {
  const names = (visit.services ?? []).map((service) => service.name);

  return names.length > 0 ? names.join(', ') : '—';
}
